import React from 'react'

const PrivacyPolicyArea = () => {
  return (
    <>
         <section id="terms_service" className="section_padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="terms_service_content">
                        <div className="terms_item">
                            <h4>Who we are</h4>
                            <p>
                                This website is operated by PCF — Pakistani Cultural &amp; Sports Organisation (“PCF”,
                                “we”, “us”), a community organisation based in Sweden. We support Pakistani families through
                                cultural activities, integration support, sports (with badminton as the main activity plus
                                seasonal swimming, cricket, and football), and children’s educational programmes.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Information we collect</h4>
                            <p>
                                When you contact us, register for activities, or subscribe to updates, we may collect your
                                name, email address, phone number, child’s age group (where relevant), and other details you
                                choose to provide. We use this information to organise events, respond to enquiries, and
                                keep you informed about PCF.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>How we use data</h4>
                            <p>
                                We process personal data to manage registrations, communicate about programmes, improve our
                                services, and meet legal obligations (for example insurance or municipal venue rules). We do
                                not sell your personal data. We may share limited information with volunteers who need it to
                                run a specific activity, or with authorities when required by law.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Photos and media</h4>
                            <p>
                                At public events we may take photos or video for PCF’s website or social media. We will
                                respect requests not to photograph identifiable children where parents have opted out. Contact
                                us if you wish to withdraw consent for existing images.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Your rights (GDPR)</h4>
                            <p>
                                Under EU/EEA data protection law you may request access, correction, deletion, or restriction
                                of your personal data, and object to certain processing. To exercise these rights, email
                                info@pcfsweden.se. You may also lodge a complaint with your national data protection
                                authority.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Contact</h4>
                            <p>
                                For privacy questions: info@pcfsweden.se. We may update this policy from time to time; the
                                latest version will always be posted on this page.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default PrivacyPolicyArea
